import React, { useEffect } from 'react';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import ApplicationsRoutes from './router/ApplicationsRoutes';
import { AuthProvider } from './contexts/AmplifyContext';
import { CssBaseline } from '@mui/material';
import { ENABLE_DEBUGGING, Node_Env } from '.././src/appsettings';
import InactivitySessionDialog from './components/InactivitySessionDialog';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { SidebarProvider } from './contexts/SidebarContext';
import { SnackbarProvider } from 'notistack';
import ThemeProvider from './theme/ThemeProvider';
import UserSessionDialog from './components/UserSessionDialog';
import log from 'loglevel';
import logger from '../src/core/logger';

logger.initialize().setEnabled(ENABLE_DEBUGGING);

function App() {
  useEffect(() => {
    log.info(`CVX.Web App is initialized [%o]`, Node_Env);
    return () => log.info(`CVX.Web App has disposed!`);
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <SnackbarProvider
          maxSnack={6}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
        >
          <SidebarProvider>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <CssBaseline />
              <UserSessionDialog />
              <InactivitySessionDialog />
              <ApplicationsRoutes />
            </LocalizationProvider>
          </SidebarProvider>
        </SnackbarProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
export default App;